import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import { Spinner } from './components/spinner/spinner';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Boostrap Libs
import $ from 'jquery';
import Popper from 'popper.js';
import 'bootstrap/dist/js/bootstrap.bundle.min';

//SBAdmin2 Style
import './assets/css/sb-admin-2.min.css';
import './assets/css/sb-admin-2-custom.css';

//Redux
import { Provider } from 'react-redux';
import { Store } from './redux/store';

ReactDOM.render(
<Provider store={Store}>
    <App /> 
    <Spinner/>
    <ToastContainer />
</Provider> , document.getElementById('root'));